import theme from '@/components/core/theme';
import { css } from '@linaria/core';

export const root = css``;

export const options = css`
  display: flex;
  align-items: center;
`;

export const option = css`
  color: ${theme.colors.peoople['gris-oscuro']};
  font-weight: 700;
  font-size: 20px;
`;

export const active = css``;

export const separator = css`
  margin: 0 1rem;
  align-self: stretch;
  width: 2px;
  background-color: ${theme.colors.peoople['gris-oscuro']};
`;

export const providers = css`
  display: flex;
  gap: 1.5rem;
  margin-top: 1rem;
`;

export const provider = css`
  width: 3rem;
  aspect-ratio: 1;
  img {
    width: 100%;
  }
`;
